<div class="" [ngStyle]="setContainerStyles(component)">
  @if (component.primary.image) {
    <div class="" role="img" aria-label="promotional image" [ngStyle]="setStyles(component)"></div>
  }
</div>
